import { useEffect, useState } from 'react';
import api from '@/lib/axios';

export const useAudienceReport = (filters) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);
  useEffect(() => {
    let active = true;
    let inFlight = false;
    const controller = new AbortController();
    const load = async () => {
      if (inFlight || document.visibilityState !== 'visible') return;
      inFlight = true; setLoading(true);
      try {
        const result = await api.get('/admin/marketplace/audience/summary', {
          params: filters, signal: controller.signal,
        });
        if (active) { setData(result.data); setError(''); }
      } catch (e) {
        if (active) setError(typeof e.response?.data?.detail === 'string' ? e.response.data.detail : 'Não foi possível atualizar a audiência. Os valores anteriores podem estar desatualizados.');
      } finally { inFlight = false; if (active) setLoading(false); }
    };
    load();
    const timer = window.setInterval(load, 15000);
    document.addEventListener('visibilitychange', load);
    return () => { active = false; controller.abort(); clearInterval(timer); document.removeEventListener('visibilitychange', load); };
  }, [filters, refreshKey]);
  return { data, error, loading, refresh: () => setRefreshKey((n) => n + 1) };
};